const breadCrumb = "Lotação de Servidores - Regime Complementar";

const routes = [
  {
    path: "/minuta-de-portaria/:id/solicitacao",
    name: "solicitacao-de-minuta-de-portaria",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/SolicitacaoMinutaDePortaria/SolicitacaoMinutaDePortariaHome.vue"
      ),
  },
  {
    path: "/minuta-de-portaria/:id/solicitacao/cadastro",
    name: "solicitacao-de-minuta-de-portaria-cadastro",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/SolicitacaoMinutaDePortaria/SolicitacaoMinutaDePortariaCad.vue"
      ),
  },

  {
    path: "/minuta-de-portaria/:id/solicitacao/visualizar/:solicitacaoId",
    name: "solicitacao-de-minuta-de-portaria-visualizar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/SolicitacaoMinutaDePortaria/SolicitacaoMinutaDePortariaShow.vue"
      ),
  },
];

export default routes;
